// extracted by mini-css-extract-plugin
export default {"page_title":"PresenterPageCard_page_title__jjenS"};